module.exports = __webpack_public_path__ + "img/driven-banner.7ef8009f.jpg";